export default __webpack_public_path__ + "static/media/1396.8cd72861.png";